/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideal Weight Calculator — Healthy Weight Range | Toolverse`)
};

const es_hw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Peso Ideal — Rango de Peso Saludable | Toolverse`)
};

const de_hw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idealgewicht-Rechner — Gesunder Gewichtsbereich | Toolverse`)
};

const nl_hw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideaal gewichtsrekenmachine — Gezond gewichtsbereik | Toolverse`)
};

const fr_hw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de poids idéal — Plage de poids santé | Toolverse`)
};

const it_hw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore Peso Ideale — Intervallo di Peso Sano | Toolverse`)
};

const pt_br2_hw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Peso Ideal — Faixa de Peso Saudável | Toolverse`)
};

const pt_hw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Peso Ideal — Intervalo de Peso Saudável | Toolverse`)
};

const ja_hw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`理想体重計算機—健康的な体重範囲 | Toolverse`)
};

const zh_hw_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`理想体重计算器——健康体重范围 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hw_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hw_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hw_meta_title", locale)
	if (locale === "en") return en_hw_meta_title(inputs)
	if (locale === "es") return es_hw_meta_title(inputs)
	if (locale === "de") return de_hw_meta_title(inputs)
	if (locale === "nl") return nl_hw_meta_title(inputs)
	if (locale === "fr") return fr_hw_meta_title(inputs)
	if (locale === "it") return it_hw_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_hw_meta_title(inputs)
	if (locale === "pt") return pt_hw_meta_title(inputs)
	if (locale === "ja") return ja_hw_meta_title(inputs)
	return zh_hw_meta_title(inputs)
};